import {FormInput, FormInputCountrySelector, FormSelect} from "@/Components/Controls";
import i18n from "i18next";
import React, {useState} from "react";
import {useForm as useFormInertia} from "@inertiajs/inertia-react";

export function useAddressForm(args) {
    return useFormInertia(
        {...args,
            line_1: '',
            save_address: '0',//Flag to save the address
            line_2: '',
            city: '',
            state: '',
            country_code: 'us', // Default to the United States
            postal_code: ''
        }
    );
}

export function updateAddressFrom(autofill, setData, setSaveAddress, args) {
    setData(
        {...args, line_1: autofill['line_1'],
            line_2: autofill['line_2'],
            save_address: 1,
            city: autofill['city'],
            state: autofill['state'],
            country_code:  autofill['country'] === "United States" ? "us" : autofill['country'],
            postal_code: autofill['postal_code']
        }
    );
    setSaveAddress('1');
}

export function validationEffects(setValidationOptions, setValidationObjects, setValidationModal, errors) {
    setValidationOptions([]);
    if(typeof errors["suggestion_addresses"] !== 'undefined') {
        let suggestedAndEntered = [...JSON.parse(errors["suggestion_addresses"]), JSON.parse(errors["entered_address"])];
        let suggestedAndEnteredStrings = suggestedAndEntered.map(option =>
            `${option['line_1']}${option['line_2'] ? "\n" + option['line_2'] : ""}
                        ${option['city'] + ", " + option['state'] + " " + option['postal_code']}
                        ${option['country'] === "us" ? "United States" : option['country']}`
        )
        setValidationObjects(suggestedAndEntered);
        setValidationOptions(suggestedAndEnteredStrings);
        setValidationModal(true);
    }
}

export default ({
                    errors,
                    data,
                    setData,
                    setSaveAddress,
                    save_address_value,
                    stateOptions,
                }) => {

    function onChange(name, value) {
        setData(name, value);
        setSaveAddress('0');
    }

    function onChangeCountryCode(code) {
        onChange('country_code', code)
    }

    return (
        <div>
            <div className="row">
                <FormInput
                    error={errors["line_1"]}
                    name="line_1"
                    isFocused={true}
                    autoComplete="line_1"
                    value={data.line_1}
                    onChange={onChange}
                    label={i18n.t("add-address.line-1")}
                    className="col-12"
                    dataTestid="address_form-input-address_line_1"
                />
                <input
                    type="hidden"
                    name="save_address"
                    value={save_address_value}
                />
            </div>
            <div className="row">
                <FormInput
                    error={errors["line_2"]}
                    name="line_2"
                    autoComplete="line_2"
                    value={data.line_2}
                    onChange={onChange}
                    label={i18n.t("add-address.line-2")}
                    className="col-12"
                    dataTestid="address_form-input-address_line_2"
                />
            </div>
            <div className="row">
                <FormInput
                    error={errors["city"]}
                    name="city"
                    autoComplete="city"
                    value={data.city}
                    onChange={onChange}
                    label={i18n.t("add-address.city")}
                    className="col-12"
                    dataTestid="address_form-input-address_city"
                />
            </div>
            <div className="row">
                {data.country_code === "us" ?
                    <FormSelect
                        error={errors["state"]}
                        name="state"
                        autoComplete="state"
                        value={data.state}
                        onChange={onChange}
                        isSearchable={true}
                        label={i18n.t("add-address.state")}
                        className="col-12"
                        dataTestid="address_form-select-address_state"
                        options={stateOptions}
                    /> :
                    <FormInput
                        error={errors["state"]}
                        name="state"
                        autoComplete="state"
                        value={data.state}
                        onChange={onChange}
                        label={i18n.t("add-address.province")}
                        className="col-12"
                        dataTestid="address_form-input-address_state"
                    />
                }
            </div>
            <div className="row country-row">
                <FormInputCountrySelector
                    error={errors["country_code"]}
                    name="country_code"
                    value={data.country_code}
                    onChange={onChangeCountryCode}
                    label={i18n.t("add-address.country-code")}
                    placeholder={i18n.t("add-address.country-code")}
                    className="col-12"
                    dataTestid="address_form-input-address_country"
                ></FormInputCountrySelector>
            </div>
            <div className="row">
                <FormInput
                    error={errors["postal_code"]}
                    name="postal_code"
                    autoComplete="zip"
                    value={data.postal_code}
                    onChange={onChange}
                    label={i18n.t("add-address.zip")}
                    className="col-12"
                    dataTestid="address_form-input-address_zip"
                />
            </div>
        </div>
    )
}
